import { Button, Form, Input, Modal, Upload, Select, DatePicker } from "antd";
import { useForm, useModal } from "@refinedev/antd";
import {
  errorNotification,
  successNotification,
  safeDayjs,
} from "../../../helpers";
import { useState } from "react";
import type { RcFile, UploadFile } from "antd/es/upload/interface";
import axAPI from "../../../api/axios-instance";
import { leagueOptions } from "../leagueOptions";

export const VideoAdd = () => {
  const { modalProps, show, close } = useModal();
  const { formProps, form, formLoading } = useForm({
    action: "create",
    resource: "video",
    dataProviderName: "videoDataProvider",
    redirect: false,
    ...successNotification({
      successData: { message: "Видео добавлено", type: "success" },
      callback: () => {
        close();
        form.resetFields();
      },
    }),
    ...errorNotification({}),
  });

  const onAfterClose = () => {
    form.resetFields();
    setFileList([]);
  };

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const uploadImage = async (file: RcFile) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const { data } = await axAPI.post(
        "/cms/image/upload/type?type=MATCH",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data,
        },
      ]);
      form.setFieldValue("img", data);
    } catch (e) {
      // ignore upload errors; form submission will handle notifications
    }
  };

  const beforeUpload = async (file: RcFile) => {
    await uploadImage(file);
    return false;
  };

  return (
    <>
      <Button type="primary" onClick={show}>
        Добавить видео
      </Button>
      <Modal
        afterClose={onAfterClose}
        title={"Добавление видео"}
        onCancel={close}
        {...modalProps}
        footer={<></>}
      >
        <Form
          style={{ width: "100%", marginTop: 16 }}
          {...formProps}
          initialValues={{ date: safeDayjs(new Date()) }}
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="Название"
            rules={[{ required: true, message: "Укажите название" }]}
          >
            <Input placeholder="Укажите название" />
          </Form.Item>
          <Form.Item
            name="link"
            label="Ссылка"
            rules={[{ required: true, message: "Укажите ссылку" }]}
          >
            <Input placeholder="Укажите ссылку" />
          </Form.Item>
          <Form.Item
            name="leagueId"
            label="Лига"
            rules={[{ required: true, message: "Укажите лигу" }]}
          >
            <Select options={leagueOptions} placeholder="Выберите лигу" />
          </Form.Item>
          <Form.Item
            name="date"
            label="Дата публикации"
            rules={[{ required: true, message: "Укажите дату" }]}
          >
            <DatePicker
              showTime={{ format: "HH:mm" }}
              format="DD.MM.YYYY HH:mm"
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Превью">
            <Upload
              maxCount={1}
              listType="picture"
              beforeUpload={beforeUpload}
              fileList={fileList}
              onRemove={() => {
                setFileList([]);
                form.setFieldValue("img", undefined);
              }}
            >
              <Button>Выбрать файл</Button>
            </Upload>
          </Form.Item>
          <Form.Item name="img" hidden />
          <Button type="primary" htmlType="submit" loading={formLoading}>
            Добавить
          </Button>
        </Form>
      </Modal>
    </>
  );
};
